import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import { FaChevronDown, FaChevronUp, FaHome, FaUserGraduate, FaBars, FaMoneyBill  } from 'react-icons/fa';
import { HiDocumentReport  } from 'react-icons/hi';
import { LiaChalkboardTeacherSolid } from "react-icons/lia";
import { MdOutlineInventory2, MdOutlinePayments } from "react-icons/md";
import { RiMiniProgramLine } from "react-icons/ri";
import { GrSchedule } from "react-icons/gr";


import './styles/Sidebar.css';

const Sidebar = ({ isCollapsed, toggleSidebar }) => {
    const { permissions } = useContext(AuthContext);
    const [activeMenu, setActiveMenu] = useState(null);

    const menuItems = [
        {
            name: 'Home',
            path: '/home',
            permission: 'HOME',
            icon: <FaHome />
        },
        {
            name: 'Student',
            icon: <FaUserGraduate />,
            subMenu: [
                { name: 'Student List', path: '/student/list', permission: 'STUDENT_LIST' },
                { name: 'New Student', path: '/student/create', permission: 'STUDENT_CREATE' },
                { name: 'Book Handover List', path: '/student/bucket/list', permission: 'STUDENT_BUCKET_LIST' },
                { name: 'Student Progress Level List', path: '/student/progressLevel/list', permission: 'STUDENT_PROGRESS_LEVEL_LIST' },
                { name: 'Student Level Up Request', path: '/student/levelup/create', permission: 'STUDENT_LEVELUP_CREATE' },
                { name: 'Student Leave', path: '/student/leave/create', permission: 'STUDENT_LEAVE_CREATE' },
                { name: 'Student Mutation', path: '/student/mutation/create', permission: 'STUDENT_MUTATION_CREATE' },
                { name: 'Student Purchase', path: '/student/purchase/create', permission: 'STUDENT_PURCHASE_CREATE' },
                
            ],
        },
        {
            name: 'Public Student',
            icon: <FaUserGraduate />,
            subMenu: [
                { name: 'Public Student List', path: '/student/public/list', permission: 'PUBLIC_STUDENT_LIST' },
                { name: 'New Public Student', path: '/student/public/create', permission: 'PUBLIC_STUDENT_CREATE' }
                
            ],
        },
        {
            name: 'Class',
            icon: <RiMiniProgramLine />,
            subMenu: [
                { name: 'Student Class List', path: '/student/class/list', permission: 'STUDENT_CLASS_LIST' },
                { name: 'Public Student Class List', path: '/student/class/public/list', permission: 'STUDENT_CLASS_PUBLIC_LIST' },
                { name: 'Student Class Create', path: '/student/class/create', permission: 'STUDENT_CLASS_CREATE' },
                
            ],
        },
        {
            name: 'Teacher',
            icon: <LiaChalkboardTeacherSolid />,
            subMenu: [
                { name: 'Teacher List', path: '/teacher/list', permission: 'TEACHER_LIST' },
                { name: 'New Teacher', path: '/teacher/create', permission: 'TEACHER_CREATE' },
                { name: 'Extra Time List', path: '/teacher/extratime/list', permission: 'TEACHER_EXTRATIME_LIST' },
                { name: 'Create Extra Time', path: '/teacher/extratime/create', permission: 'TEACHER_EXTRATIME_CREATE' }, //khusus teacher
                { name: 'Teacher Attendance', path: '/teacher/attendance/create', permission: 'TEACHER_ATTENDANCE_CREATE' },
                { name: 'Teacher Leave Request ', path: '/teacher/leave/create', permission: 'TEACHER_LEAVE_CREATE' }
                
            ],
        },
        {
            name: 'Schedule',
            icon: <GrSchedule />,
            subMenu: [
                { name: 'Student Scheduler', path: '/student/schedule/assign', permission: 'STUDENT_SCHEDULE_ASSIGN' },
                { name: 'Schedule Report', path: '/schedule/report', permission: 'SCHEDULE_REPORT' }
                
            ],
        },
        {
            name: 'Stock',
            icon: <MdOutlineInventory2 />,
            subMenu: [
                { name: 'Create Stock', path: '/inventory/createnewitem', permission: 'STUDENT_LIST' },
                { name: 'Stock List', path: '/inventory/list', permission: 'INVENTORY_LIST' },
                { name: 'Stock Branch List', path: '/inventoryBranch/list', permission: 'INVENTORY_BRANCH_LIST' },
                { name: 'Stock Entry', path: '/inventory/create', permission: 'INVENTORY_CREATE' },
                { name: 'Stock Transfer', path: '/inventory/transfer', permission: 'INVENTORY_TRANSFER' },
                { name: 'Request Book', path: '/inventory/bookRequest/create', permission: 'INVENTORY_BOOK_REQUEST_CREATE' },
            ],
        },
        {
            name: 'Price List',
            icon: <FaMoneyBill />,
            subMenu: [
                { name: 'Program Price List', path: '/cost/list', permission: 'COST_LIST' },
                { name: 'Inventory Price List', path: '/inventory/pricelist', permission: 'INVENTORY_PRICE_LIST' },
                { name: 'Extra Time Price List', path: '/extrafee/list', permission: 'EXTRA_FEE_LIST' },
            ],
        },
        {
            name: 'Finance',
            icon: <MdOutlinePayments />,
            subMenu: [
                { name: 'Income List', path: '/income/list', permission: 'INCOME_LIST' },
                { name: 'Expense List', path: '/expense/otherexpense/list', permission: 'OTHER_EXPENSE_LIST' },
                { name: 'Create Expense', path: '/expense/otherexpense/create', permission: 'OTHER_EXPENSE_CREATE' },
                { name: 'Student Saving List', path: '/student/saving/report', permission: 'STUDENT_SAVING_REPORT' }
            ],
        },
        {
            name: 'Report',
            icon: <HiDocumentReport />,
            subMenu: [
                { name: 'Income Daily Report', path: '/paymentreportdaily', permission: 'INCOME_DAILY_REPORT' },
                { name: 'Kidola Monthly Report', path: '/paymentreportmonthly', permission: 'PAYMENT_REPORT_MONTHLY' },
                { name: 'Teacher Attendance Report', path: '/teacher/attendance/monthlyReport', permission: 'TEACHER_ATTENDANCE_MONTHLY_REPORT' },
                { name: 'Teacher Extra Time Report', path: '/teacher/extratime/monthlyReport', permission: 'EXTRA_TIME_MONTHLY_REPORT' }
                
            ],
        },
        {
            name: 'Utilities',
            icon: <HiDocumentReport />,
            subMenu: [
                { name: 'Create Branch', path: '/branch/create', permission: 'BRANCH_CREATE' },
                { name: 'Create Event Program', path: '/program/event/create', permission: 'EVENT_PROGRAM_CREATE' }
                
            ],
        },
    ];

    const handleMenuClick = (menuName) => {
        setActiveMenu(activeMenu === menuName ? null : menuName); // Toggle the submenu visibility
    };

    return (
        <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
            <div className="sidebar-header">
                <h3 className="sidebar-logo">
                    <FaBars onClick={toggleSidebar} className="menu-toggle-icon" /> {/* Changed to FaBars */}
                </h3>
            </div>
            <ul className="menu-list">
                {menuItems.map((menuItem) => {
                    if (menuItem.subMenu) {
                        const subMenuItems = menuItem.subMenu.filter(subItem => permissions.some(p => p.permission_name === subItem.permission));
                        if (subMenuItems.length > 0) {
                            return (
                                <li key={menuItem.name} className="menu-item">
                                    <div className="menu-item-header" onClick={() => handleMenuClick(menuItem.name)}>
                                        <div className="menu-icon-text">
                                            {menuItem.icon && <span className="icon">{menuItem.icon}</span>}
                                            {!isCollapsed && <span className="menu-text">{menuItem.name}</span>}
                                        </div>
                                        {!isCollapsed && (
                                            <span className="collapse-icon">
                                                {activeMenu === menuItem.name ? <FaChevronUp /> : <FaChevronDown />}
                                            </span>
                                        )}
                                    </div>
                                    {activeMenu === menuItem.name && (
                                        <ul className={`submenu ${isCollapsed ? 'collapsed' : ''}`}>
                                            {subMenuItems.map((subItem) => (
                                                <li key={subItem.name}>
                                                    <Link to={subItem.path}>{subItem.name}</Link>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </li>
                            );
                        }
                    } else if (permissions.some(p => p.permission_name === menuItem.permission)) {
                        return (
                            <li key={menuItem.name} className="menu-item">
                                <Link className="menu-item-link" to={menuItem.path}>
                                    <div className="menu-icon-text">
                                        {menuItem.icon && <span className="icon">{menuItem.icon}</span>}
                                        {!isCollapsed && <span className="menu-text">{menuItem.name}</span>}
                                    </div>
                                </Link>
                            </li>
                        );
                    }
                    return null;
                })}
            </ul>
        </div>
    );
};

export default Sidebar;
